/*
 * @Description 组件 AutoMap 自动生成地图
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div class="view-page-box">
		<el-form label-width="140px" ref="filterForm" :rules="rules" :model="filters" style="height: 90px;overflow: hidden;padding: 20px 0px;">
            <el-form-item label="实际长度（米）" prop="realWidth" style="display: inline-block;width: 30%;margin: 0;">
            	<el-input v-model="filters.realWidth" placeholder="请输入实际长度" clearable/>
            </el-form-item>
            <el-form-item label="实际宽度（米）" prop="realHeight" style="display: inline-block;width: 30%;margin: 0;margin-left: 10px;">
            	<el-input v-model="filters.realHeight" placeholder="请输入实际宽度" clearable/>
            </el-form-item>
            <el-form-item label-width="20px" style="display: inline-block;width: auto;margin: 0;">
                <el-button type="primary" size="primary" @click="handleBtn()">{{filters.submitButton}}</el-button>
            </el-form-item>
        </el-form>
		
		<div class="img-item-box" >
			<img v-if="!$checkEmpty(handleSrc)" :src="handleSrc" >
		</div>
		
	</div>
</template>

/* JS */
<script>
	// 地图 img
	import defaultImg from '@/static_dazzle/images/template/grid-20px-500x500.png';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "AutoMap",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 参数
				filters: {
					// 实际距离
					realWidth: '',
					realHeight: '',
					submitButton: '获取地图'
				},
				// 参数 地图
				mapFilters: {
					// 地图距离
					mapWidth: '',
					mapHeight: '',
					// 比例
					scaleX: '20/1',
					scaleY: '20/1',
				},
				
				rules: {
					realWidth: [
						{ required: true, message: '实际长度不能为空', trigger: 'blur' }
					],
					realHeight: [
						{ required: true, message: '实际宽度不能为空', trigger: 'blur' }
					],
				},// rules
				
				// 裁剪的地图
				handleSrc: '',
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 获取地图
			 * @Auth
			 * @Date
			 */
			handleBtn() {
				this.$refs['filterForm'].validate(valid => {
					// 校验通过
					if (valid) {
						
						let scaleXs = this.mapFilters.scaleX.split('/');
						let scaleYs = this.mapFilters.scaleY.split('/');
						
						// 参数 地图
						this.mapFilters.mapWidth = Math.ceil(this.filters.realWidth) * scaleXs[0] / scaleXs[1];
						this.mapFilters.mapHeight = Math.ceil(this.filters.realHeight) * scaleYs[0] / scaleYs[1];
						
						// 裁剪的地图
						this.$SubFn.sliceImg({
							src: defaultImg,
							rect: {
								x: 0, // 截取方格左上角横坐标
								y: 0, // 截取方格左上角纵坐标
								width: this.mapFilters.mapWidth, // 截取方格宽度
								height: this.mapFilters.mapHeight // 截取方格高度
							}
						}).then(result => {
							// 裁剪的地图
							this.handleSrc = result;
						}).catch(error => {
							// 裁剪的地图
							this.handleSrc = '';
						});
						
					}
				});
			},
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	.img-item-box {
		height: calc(100% - 90px);
		width: 100%;
		position: relative;
		
		img {
			height: auto;
			width: auto;
			max-width: calc(100% - 10px);
			max-height: calc(100% - 10px);
			
			position: absolute;
			top: 50px;
			bottom: 50px;
			left: 5px;
			right: 5px;
			margin: auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/system-manager/map/AutoMap.vue